import http from 'plugins/axios';

export default {
  getRecords(data) {
    return http.get({
      url: '/la/admin/purchase/searchResult',
      data
    });
  },
  getWinningRate(data) {
    return http.get({
      url: '/la/admin/purchase/getDTOR',
      data
    });
  }
};
